import { translate } from "../../app/utils";
import "./OpenSource.css";

import ajolLogo from "../../assets/images/open_source_logos/ajol_logo.png";
import bookShareLogo from "../../assets/images/open_source_logos/bookshare_logo.png";
import doabLogo from "../../assets/images/open_source_logos/doab_logo.png";
import imfLogo from "../../assets/images/open_source_logos/imf_elibrary_logo.png";
import jstorLogo from "../../assets/images/open_source_logos/jstor_logo.svg";
import okrLogo from "../../assets/images/open_source_logos/okr_logo.svg";
import researchGateLogo from "../../assets/images/open_source_logos/research_gate_logo.svg";
import ssoarLogo from "../../assets/images/open_source_logos/ssoar_logo.png";
import wbgLogo from "../../assets/images/open_source_logos/wbg_logo.svg";
import { Tooltip } from "@mui/material";

const OpenSource = () => {
  const items = [
    {
      title: "African Journals Online",
      link: "https://www.ajol.info/index.php/ajol",
      image: ajolLogo,
    },
    {
      title: "Bookshare",
      link: "https://www.bookshare.org/",
      image: bookShareLogo,
    },
    {
      title: "Directory of Open Access Books (DOAB)",
      link: "https://www.doabooks.org/",
      image: doabLogo,
    },
    {
      title: "ResearchGate",
      link: "https://www.researchgate.net/",
      image: researchGateLogo,
    },
    {
      title: "Open Knowledge Repository",
      link: "https://openknowledge.worldbank.org/home",
      image: okrLogo,
    },
    {
      title: "JSTOR",
      link: "https://www.jstor.org/",
      image: jstorLogo,
    },
    {
      title: "Social Science Open Access Repository",
      link: "https://www.ssoar.info/ssoar/discover?query=microeconomics+modelling&submit=Go",
      image: ssoarLogo,
    },
    {
      title: "IMF eLibrary",
      link: "https://www.elibrary.imf.org/",
      image: imfLogo,
    },
    {
      title: "World Bank Group",
      link: "https://documents.worldbank.org/en/publication/documents-reports",
      image: wbgLogo,
    },
  ];
  return (
    <div id="open-source-container">
      <h3>{translate("openSource")}</h3>

      <div className="open-source-cards mb-50 flex-row flex-wrap">
        {items.map((item) => (
          <Tooltip title={item.title}>
            <a href={item.link} target="_blank" rel="noreferrer">
              <div className="open-source-item">
                <div className="img">
                  <img src={item.image} alt="" />
                </div>
                {/* <div className="title">{item.title}</div> */}
              </div>
            </a>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

export default OpenSource;
